import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import PlayerActions from 'reducers/Player'
import { thunks as AuthThunks } from 'reducers/Auth'
import { RoundCornerButton } from 'components'

/**
 * @desc Forced logout modal. Shown on token expiry and is used to force user to re-log in
 * @memberof components
 *
 * @param  {Function} t                      		[i18 string getter (Autowired)]
 * @param  {Function} dispatch                      [Redux dispatch method (Autowired)]
 *
 * @type {PureComponent}
 */

@connect()
@withTranslation()
export default class LogoutDisclaimerModal extends React.PureComponent {
  static propTypes = {
    t: PropTypes.func,
    dispatch: PropTypes.func.isRequired
  }
  static defaultProps = {
    t: (v) => v
  }

  handleConfirmClick = () => {
    const { dispatch } = this.props
    dispatch(AuthThunks.logout())
    dispatch(PlayerActions.updatePlayerState(false))
  }

  render() {
    const { t } = this.props

    return (
      <div className="fixed bg-modalBackdrop z-50 top-0 bottom-0 left-0 right-0 flex items-center justify-center">
        <div className="bg-white w-full max-w-md rounded">
          <div className="bg-gray-225 rounded-t pt-2 pb-1 text-center">
            {t('error.session-expired-title')}
          </div>
          <div className="pt-10 pb-8 text-center text-sm">
            {t('error.session-expired-message')}
            <RoundCornerButton
              text={t('general.ok')}
              className="bg-navyBlue text-gray-225 shadow-button px-10 py-1 m-auto mt-8 font-light"
              onClick={this.handleConfirmClick}
            />
          </div>
        </div>
      </div>
    )
  }
}
